import LowerAustriaCase from "../Components/References/LowerAustriaCase"
import Footer from "../Components/Footer";

const LowerAustria = () => {
    return (
      <div>
        <LowerAustriaCase />
        <Footer />
      </div>
    );
  };
  
  export default LowerAustria;